import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      height: "70vh",
    },
  },
}));

const LoadingComponet = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CircularProgress size={50} color="primary" />
    </div>
  );
};
export default LoadingComponet;
